import React from "react";

/**
 * Elegant section overline — rose-gold gradient hairlines flanking a Bebas Neue
 * eyebrow, plus a small diamond ornament. Use at the top of every marquee section.
 */
export const LuxeOverline = ({ children, align = "left", tone = "dark" }) => {
  const isLight = tone === "light";
  const eyebrow = isLight ? "text-[#E4B2A8]" : "text-[#B76E79]";
  return (
    <div
      className={`flex items-center gap-3 ${align === "center" ? "justify-center" : ""}`}
      data-testid="luxe-overline"
    >
      <span className="h-px w-8 md:w-14 bg-gradient-to-r from-transparent via-[#B76E79] to-[#E4B2A8]" />
      <span className={`w-1.5 h-1.5 rotate-45 ${isLight ? "bg-[#E4B2A8]" : "bg-[#B76E79]"}`} />
      <p className={`overline ${eyebrow} tracking-[0.35em]`}>{children}</p>
      <span className={`w-1.5 h-1.5 rotate-45 ${isLight ? "bg-[#E4B2A8]" : "bg-[#B76E79]"}`} />
      <span className="h-px w-8 md:w-14 bg-gradient-to-r from-[#E4B2A8] via-[#B76E79] to-transparent" />
    </div>
  );
};

/**
 * Small decorative divider — rose-gold gradient line with center diamond.
 */
export const LuxeDivider = ({ className = "" }) => (
  <div className={`flex items-center gap-3 ${className}`}>
    <span className="h-px flex-1 bg-gradient-to-r from-transparent to-[#B76E79]/50" />
    <span className="w-2 h-2 rotate-45 bg-gradient-to-br from-[#E4B2A8] to-[#B76E79]" />
    <span className="h-px flex-1 bg-gradient-to-r from-[#B76E79]/50 to-transparent" />
  </div>
);

export default LuxeOverline;
